import React, { useState } from 'react';
import yaml from 'js-yaml';
import FileUpload from './components/FileUpload';
import ConfigForm from './components/ConfigForm';

function App() {
  const [config, setConfig] = useState(null);
  const [activeTab, setActiveTab] = useState('server');

  const handleFileUpload = (yamlContent) => {
    try {
      const parsedConfig = yaml.load(yamlContent);
      setConfig(parsedConfig);
    } catch (error) {
      alert('Error parsing YAML file: ' + error.message);
    }
  };

  const handleExport = () => {
    if (!config) return;
    
    const yamlString = yaml.dump(config, { indent: 2 });
    const blob = new Blob([yamlString], { type: 'text/yaml' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'pygeoapi.config.yml';
    a.click();
    URL.revokeObjectURL(url);
  };

  const handleReset = () => {
    setConfig(null);
    setActiveTab('server');
  };

  return (
    <div className="min-vh-100" style={{backgroundColor: '#f8f9fa'}}>
      {/* Navbar */}
      <nav className="navbar navbar-expand-lg navbar-dark bg-primary shadow-sm">
        <div className="container">
          <a className="navbar-brand fw-bold" href="#">
            <i className="bi bi-gear-fill me-2"></i>
            pygeoapi Config Generator
          </a>
          <div className="navbar-nav ms-auto">
            <a className="nav-link" href="https://github.com/krishnaglodha/pygeoapiface" target="_blank" rel="noopener noreferrer">
              <i className="bi bi-github me-1"></i>
              Fork Repo
            </a>
            <a className="nav-link" href="mailto:krishna@rottengrapes.tech">
              <i className="bi bi-envelope me-1"></i>
              Contact Us
            </a>
          </div>
        </div>
      </nav>

      <div className="container py-4">
        {!config ? (
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <div className="text-center mb-5">
                <h1 className="display-5 fw-bold text-primary mb-3">Welcome to pygeoapi Config Generator</h1>
                <p className="lead text-muted">Upload your configuration file to get started with editing</p>
              </div>
              <FileUpload onFileUpload={handleFileUpload} />
            </div>
          </div>
        ) : (
          <div>
            <div className="d-flex justify-content-between align-items-center mb-4">
              <div>
                <h2 className="text-primary mb-1">Configuration Editor</h2>
                <p className="text-muted mb-0">Edit your pygeoapi configuration settings</p>
              </div>
              <div className="btn-group">
                <button className="btn btn-outline-secondary" onClick={handleReset}>
                  <i className="bi bi-arrow-left me-1"></i>
                  New File
                </button>
                <button className="btn btn-success" onClick={handleExport}>
                  <i className="bi bi-download me-1"></i>
                  Export YAML
                </button>
              </div>
            </div>
            
            <div className="card shadow-sm">
              <div className="card-header bg-white">
                <ul className="nav nav-pills card-header-pills">
                  {[
                    { key: 'server', icon: 'bi-server', label: 'Server' },
                    { key: 'logging', icon: 'bi-journal-text', label: 'Logging' },
                    { key: 'metadata', icon: 'bi-info-circle', label: 'Metadata' },
                    { key: 'resources', icon: 'bi-collection', label: 'Resources' }
                  ].map(tab => (
                    <li className="nav-item" key={tab.key}>
                      <button 
                        className={`nav-link ${activeTab === tab.key ? 'active' : ''}`}
                        onClick={() => setActiveTab(tab.key)}
                      >
                        <i className={`${tab.icon} me-1`}></i>
                        {tab.label}
                      </button>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="card-body">
                <ConfigForm 
                  config={config} 
                  setConfig={setConfig} 
                  activeTab={activeTab} 
                />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

export default App;